
import React from 'react';
import { Anchor, Box } from 'grommet';

const ClearLink = ({clear}) => {
    const onClick = () => {
        clear();
    }

    return (
        <Box pad={{right: '8px'}} direction="row" justify="end">
            <Anchor
                label="Vyčistit vyhledané nebo zobrazené objekty"
                onClick={onClick}
            />
        </Box>
    );
}

export default ClearLink;
